import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import {
    AngularFirestore,
    AngularFirestoreCollection,
    DocumentChangeAction,
    Query,
    QueryDocumentSnapshot,
    QueryFn,
} from '@angular/fire/firestore';

import firebase from 'firebase/app';

export {
    AngularFirestoreCollection,
    DocumentChangeAction as AngularFirestoreDocumentChangeAction,
    Query as AngularFirestoreQuery,
    QueryDocumentSnapshot as AngularFirestoreQueryDocumentSnapshot,
};

import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class FirestoreService {
    constructor(public auth: AngularFireAuth, public firestore: AngularFirestore) {}

    /** Firestore Cloud Function */
    public cloudFunction(name: string): firebase.functions.HttpsCallable {
        return this.firestore.firestore.app.functions(environment.firebaseConfig.region).httpsCallable(name);
    }

    /** Firestore Collection */
    public collection<T>(path: string, queryFn?: QueryFn): AngularFirestoreCollection<T> {
        return this.firestore.collection<T>(path);
    }

    /** Firestore Collection with initial path /tenant/{tenantId}/  */
    public tenantDependentCollection<T>(tenantId: string, partialPath: string, queryFn?: QueryFn): AngularFirestoreCollection<T> {
        // removes leading '/' if the partial path has it
        if (partialPath && partialPath[0] === '/') {
            partialPath = partialPath.substring(1, partialPath.length);
        }

        const finalPath = `/tenants/${tenantId}/${partialPath}`;

        return this.firestore.collection(finalPath, queryFn);
    }
}
